<template>
  <main v-if='kirby.page.intendedTemplate == "artists"'>
    <section class="abovefold">

      <figure>
        <transition tag='div' name='slow' v-for='(artist, name, index) in artists' :key='index'>
          <img v-show='index == current' :srcset='artist.strings.srcset' sizes='50vw' />
        </transition>
      </figure>

      <h6 v-html='kirby.pages[$route.params.year].children.artists.strings.title' />
      <nav>
        <router-link :to='"/"+page.uri'
                     v-show='page.visible'
                     v-for='(page, uri, bindex) in artists'
                    :class='{ "active" : (current == bindex) }'
                     :key='bindex'>
          <h1 v-html='page.strings.title' @mouseover='hover(bindex)' @mouseleave='start()' />
        </router-link>
      </nav>

    </section>

    <MainFooter />

  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function() {
    return {
      current: 0,
    }
  },
  computed: {
    artists: function() {
      if(this.kirby.pages[this.$route.params.year]) return this.kirby.pages[this.$route.params.year].children.artists.children;
    },
    length: function() {
      return Object.keys(this.artists).length
    }
  },
  mounted () {
    this.start();
  },
  beforeDestroy () {
    this.cancel();
  },
  methods: {
    start () {
      this.timer = setInterval(this.tick, 1500);
    },
    tick () {
      this.current = (this.current + 1 < this.length) ? (this.current + 1) : 0;
    },
    cancel () {
      clearInterval(this.timer);
    },
    hover(index) {
      clearInterval(this.timer);
      this.current = index;
    }
  },
  watch: {
    artists: function(){
      if(this.length > 0 && this.current == 0) {
        this.current = Math.floor(Math.random() * this.length);
      }
    }
  },
}
</script>

<style scoped>
  main {
    box-sizing: border-box;
    padding-top: 9rem;
  }

  section.abovefold {
    box-sizing: border-box;
    height: var(--abovefold);
    flex-direction: column;
    display: flex;
    justify-content: flex-end;

  }
  figure {
    flex: 1;
    flex-shrink: 1;
    overflow: hidden;
  }
  nav {
    font-size: var(--large);
    font-weight: 100;
    line-height: 1em;
    text-indent: var(--textindent);
  }
  a {
    text-indent: 0;
    display: inline-block;
    font-size: var(--large);
    line-height: 1em;
    white-space: nowrap;
  }
  nav a * {
    color: var(--gray);
    will-change: color;
    transition: color 0.3s ease-in-out;
  }
  a:hover h1, a.active h1 {
    color: var(--darkgray);
  }
  a.router-link-exact-active h1 {
    color: var(--darkgray);
  }
  a+a {

  }
  a:not(:last-child)::after {
    font-family: Face;
    font-size: inherit;
    display: inline-block;
    content: ', ';
    margin-right: 0.1em;
    line-height: inherit;
  }
  h1 {
    font-size: inherit;
    display: inline-block;
    line-height: inherit;
  }
  h6 {
    margin-top: 2em;
  }
  figure {
    position: relative;
  }
  div {
    position: relative;
  }
  img {
    top: 0;
    left: 0;
    position: absolute;
    height: 100%;
    width: auto;
    max-width: 60rem;
    object-fit: contain;
    object-position: bottom;
  }
</style>
